if (document.body.classList.contains('template-collection')) {
  const heroTitles = document.querySelectorAll('.hero__overlay__content .hero__title');

  heroTitles.forEach((title) => {
    if (title.tagName.toLowerCase() === 'h2') {
      const h1 = document.createElement('h1');

      // Copy attributes
      [...title.attributes].forEach(attr => {
        h1.setAttribute(attr.name, attr.value);
      });

      // Copy content
      h1.innerHTML = title.innerHTML;

      // Replace h2 with h1
      title.parentNode.replaceChild(h1, title);
    }
  });
}

if (window.location.pathname === '/collections/bins-liners/kitchen') {
    window.location.replace('/collections/bins-liners');
  }

  if (window.location.pathname === '/collections/cleaning/kitchen') {
    window.location.replace('/collections/cleaning');
  }